import useSWR from 'swr';
import { getFetcher } from '@/api/fetchers';
import { useParams } from 'react-router-dom';
import { type EmployeeAttachments } from '@/schemas/API/GET/employee/attachment/response';

/**
 * Hook that fetches employee's attachments based on the employeeId in the URL.
 */
const useEmployeeAttachements = () => {
  const { employeeId } = useParams<{ employeeId: string }>();

  const {
    data: attachments,
    error,
    mutate,
  } = useSWR<EmployeeAttachments>(
    employeeId ? `/employees/${employeeId}/attachments` : null,
    getFetcher
  );

  return {
    attachments,
    error,
    mutate,
  };
};

export default useEmployeeAttachements;
